var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.109 17.682c1.614-.767 2.636-2.541 2.636-4.83 0-3.091-1.867-5.252-4.542-5.252-2.674 0-4.542 2.161-4.542 5.251 0 2.284 1.022 4.053 2.63 4.826-3.437.324-5.49 1.73-5.49 6.158 0 .148.057.29.16.395a.544.544 0 0 0 .777 0 .565.565 0 0 0 .16-.395c0-3.874 1.533-5.123 6.316-5.123 4.783 0 6.288 1.3 6.288 5.128 0 .149.058.291.16.396a.544.544 0 0 0 .777 0 .565.565 0 0 0 .161-.396c0-4.394-2.142-5.822-5.491-6.158Zm-5.35-4.83c0-2.055 1.066-4.132 3.444-4.132s3.443 2.077 3.443 4.131c0 2.055-1.065 4.132-3.443 4.132s-3.46-2.072-3.46-4.126l.017-.006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.009127310532d6596f36b12f8876e9fb.svg";
export { ForwardRef as ReactComponent };